<template>
  <div class="loginform">
    <h1>Login</h1>
    <transition name="slide">
      <div class="alert" v-if="this.formError">{{errorMessage}}</div>
    </transition>
    <form @submit.prevent="login" class="flexform">
      <input type="text" ref="username" name="username" v-model="input.username" placeholder="Email" />
      <input type="password" ref="password" name="password" v-model="input.password" placeholder="Password" />
      <input type="submit" value="Login" />
    </form>
    <p>Don't have an account? <router-link to="/register"><a>Register</a></router-link>
    <p>Forgot Password? <router-link to="/password/forgot"><a>Reset it</a></router-link>
</p>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1 {
    font-size: 48px;
  }
</style>

<script>

import {store} from '@/store'
import DataUser from '@/data/controllers/DataUser'

export default {
  name: 'Login',
  data () {
    return {
      input: {
        username: '',
        password: ''
      },
      errorMessage: 'Invalid username/password combination',
      formError: false
    }
  },
  methods: {
    login () {
      if (this.input.username === '') {
        alert('username is necessary')
        this.$refs.username.focus()
      } else if (this.input.password === '') {
        alert('password is required')
      } else {
        let params = {'email': this.input.username, 'password': this.input.password}
        let $this = this
        store.commit('setFullPageLoader', {
          active: true,
          message: 'Logging you in...'
        })
        this.$axios.post(process.env.API_BASE + 'api/login', params)
          .then(
            (response) => {
              let { data } = response
              let apiToken = data.data['api_token']
              store.commit('updateKey', {
                key: apiToken
              })
              $this.$cookie.set('key', apiToken, 30)
              $this.formError = false
              this.$router.push('/')
              store.commit('setFullPageLoader', {
                active: false,
                message: 'Loading'
              })
              let DUserInfo = {
                isAdmin: data.data['is_admin'] * 1,
                token: apiToken
              }
              DataUser.setData(DUserInfo)
            },
            (error) => {
              console.log(error)
              $this.formError = true
              store.commit('setFullPageLoader', {
                active: false,
                message: 'Loading'
              })
            }
          )
      }
    }
  },
  mounted () {
    if (this.$parent.key) {
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/auth/Login.vue